import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useParams, useNavigate } from "react-router-dom";

const EmailTemplateEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subject, setSubject] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/email-templates/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setSubject(data.subject || "");

        // Convert HTML string to editor blocks
        const html = data.body || "";
        const contentBlock = htmlToDraft(html);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        setEditorState(EditorState.createWithContent(contentState));
      })
      .catch((err) => console.error("Failed to fetch template", err));
  }, [id]);

  const handleSave = async () => {
    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const payload = {
      subject,
      body: htmlContent,
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/email-templates/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (res.ok) {
        alert("✅ Template updated");
        navigate("/admin/email-templates");
      } else {
        alert(`❌ ${data.message}`);
      }
    } catch (err) {
      alert("❌ Failed to update template");
      console.error(err);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Edit Email Template</h1>

      <div className="mb-4">
        <label className="block font-semibold mb-1">Subject</label>
        <input
          type="text"
          className="w-full border rounded p-2"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label className="block font-semibold mb-1">Body</label>
        <Editor
          editorState={editorState}
          onEditorStateChange={setEditorState}
          wrapperClassName="border rounded"
          editorClassName="p-2 bg-white min-h-[200px]"
          toolbarClassName="border-b"
        />
      </div>

      <button
        onClick={handleSave}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Save Changes
      </button>
    </div>
  );
};

export default EmailTemplateEditPage;
